<template>
  <Modal @close="$emit('close')" width="400px">
    <Form @request="sealDocument">
      <h2 style="margin-bottom: 24px">Печать</h2>
      <div
        v-if="period"
        class="row"
      >
        <VInput
          required
          v-model="startDate"
          name="start_at"
          type="date"
          placeholder="Период от"
        />
        <VInput
          required
          v-model="finishDate"
          name="finish_at"
          type="date"
          placeholder="Период до"
        />
      </div>
      <VSelect
        v-model="documentType"
        required
        name="sealDoc"
        placeholder="Вид документа"
        :items="sealDocOptions"
        style="margin-bottom: 24px"
        itemText="name"
      />
      <VSelect
          v-if="isApplication && contracts.length > 1"
          v-model="contract"
          name="contract"
          placeholder="Договор с агенством"
          :items="contracts ? contracts : []"
          style="margin-bottom: 24px"
          itemText="name"
      />
      <VSwitch
          v-model="switchVip"
          label="Только Руководство/VIP"
          style="margin-bottom: 24px"
      />
      <Button
        :loading="loading"
        width="100%"
        height="48px"
        text="Печать"
        class="btn-primary"
        style="margin-bottom: 16px"

      />
      <Button
        @click.native.prevent="$emit('close')"
        width="100%"
        height="48px"
        text="Отменить"
        class="btn-secondary"
      />
    </Form>
  </Modal>
</template>

<script>
import Modal from "@/components/Modals/Modal.vue";
import Form from "@/components/Form/Form.vue";
import VSelect from "@/components/Form/VSelect.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import Button from "@/components/Button.vue";
import {getGeneralReports,getGeneralReportsDeparture, getReports} from "@/api/orders";
import {mapState} from "vuex";
import VSwitch from "@/components/VSwitch.vue";

// const USER_MODEL = "App\\Models\\User\\User";

export default {
  components: {
    VSwitch,
    Form,
    VSelect,
    Button,
    Modal,
    VInput
  },
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
    orderIds: {
      type: Array,
      default: () => [],
    },
    propOptions: {
      type: Array,
      default: () => [],
    },
    period: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      loading: false,
      sealDocOptions: this.propOptions.length
        ? this.propOptions
        : [
            { name: "Заявка на оформление билетов", id: 1, type: 'ticketing' },
            { name: "Заявка на обмен / возврат билетов", id: 1, type: 'refund' },
          ],
      documentType: null,
      finishDate: null,
      startDate: null,
      contract: null,
      // order: {},
      passengers: [],
      switchVip: false
    };
  },
  mounted() {
    // this.orderIds.forEach(orderId => {
    //   getOrder(orderId).then(res => this.order = res.data)
    //   this.contract = this.order.contract
    //   this.order.passengers.forEach(user => {
    //     this.passengers.push( {
    //       passenger_id: user.person.id,
    //       model_passenger: USER_MODEL
    //     })
    //   })
    // });
  },
  computed: {
    ...mapState("contracts", ["contracts"]),
    isApplication() {
      return this.documentType?.id === 1
    }
  },
  methods: {
    async sealDocument({ sealDoc }) {
      this.loading = true
      this.startDate = this.startDate + ' 00:00'
      this.finishDate = this.finishDate + ' 00:00'
      var params = {}
      try {
        let res;
        if (sealDoc?.id === 1) {
          params = {
            order_ids: this.orderIds
          }
          if (this.contracts.length === 1) {
            params = {
              order_ids: this.orderIds,
              contract_id: this.contracts[0].id,
              is_vip: this.switchVip
            }
          } else {
            params = {
              order_ids: this.orderIds,
              contract_id: this.contract?.id,
              is_vip: this.switchVip
            }
          }
          params.type = sealDoc?.type
          res = await getReports(params)
        } else if (sealDoc?.id === 2) {
          if (this.period) {
            params = {
              start_date: this.startDate,
              finish_date: this.finishDate,
              is_vip: this.switchVip
            }
          } else {
            params = {
              order_ids: this.orderIds,
              is_vip: this.switchVip
            }
          }
          res = await getGeneralReports(params)
        } else if (sealDoc?.id === 3) {
          params = {
              start_date: this.startDate,
              finish_date: this.finishDate,
              is_vip: this.switchVip
          }
          res = await getGeneralReportsDeparture(params)
        }

        const file_path = res.data.file_url
        const a = document.createElement("a")
        a.href = file_path
        a.download = file_path.substr(file_path.lastIndexOf("/") + 1)
        a.click()
        a.remove()

        await this.callback()
      } catch (err) {
        Promise.reject(err)
      }
      this.loading = false
      this.$emit("close")
    },
  }
}
</script>

<style scoped lang="scss">

.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}

.date-input {
  width: calc(50% - 5px) !important;
}

</style>
